import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { ButtonPink, ButtonRed, ThemeSwitcher } from '../../components/common/Button'
import { AuthInput, Input } from '../../components/common/Input'
import { ErrorValidator, SuccessValidator } from '../../components/common/Validator';


import LovrFire from '../../lovrfire'


export default function ResetPassword() {
    const [email, setEmail] = useState("");
    const [buttonState, setButtonState] = useState("SEND PASSWORD LINK")
    const [emailSent, setEmailSent] = useState(false);
    const [error, setError] = useState('')


    const validateEmail = (emailField) => {
        // var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        // if (reg.test(emailField) == false) {
        //     return false;
        // }
        // return true;
        if (emailField.length > 3) return true
        else return false

    }

    const handleSendPasswordResetEmail = async () => {
        setButtonState("Please wait...")
        setEmailSent(false);
        setError('')
        try {
            if (validateEmail(email)) {
                if (email.includes('@')) {
                    await LovrFire.auth().sendPasswordResetEmail(email.trim());
                    setButtonState("RESET LINK SENT!")
                    setError('');
                    setEmailSent(true);
                } else {
                    const userEmail = await LovrFire.firestore().collection('users').where('username', '==', email.toLowerCase().trim()).limit(1).get()
                    console.log(userEmail.docs)
                    if (userEmail.docs.length > 0) {
                        await LovrFire.auth().sendPasswordResetEmail(userEmail.docs[0].data().email.trim());
                        setButtonState("RESET LINK SENT!")
                        setError('');
                        setEmailSent(true);
                    } else {
                        setError("Username not found")
                        setButtonState("SEND PASSWORD LINK")
                        setEmailSent(false);
                    }
                }

            } else {
                setError("Email is invalid")
                setButtonState("SEND PASSWORD LINK")
                setEmailSent(false);

            }
        } catch (e) {
            if (e.code === 'auth/user-not-found') {
                setError('Email Address not Found')
                setButtonState("SEND PASSWORD LINK")
                setEmailSent(false);
            }
        }
    }

    const history = useHistory()
    const gotoLogin = () => {
        history.push('/login')
    }
    return (
        <div className='password-auth-card-wrapper' >
            <ThemeSwitcher />
            <div className='lover-authCard-wrapper-header'>
                <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            </div>
            <p className='auth-header'>Forgot Password</p>
            {/* <p className="error-text">{error}</p> */}
            <p className='auth-header-sub-text'>You forgot your password? Don’t worry, just type either the email address or username on the account.</p>
            <p style={{ marginBottom: '54px' }} className="auth-header-sub-text">Check your inbox for a password reset email and click on the URL provided in the email and enter a new password.</p>
            <div style={{ width: '400px', maxWidth: '98%' }}>
                <AuthInput handleInputChange={e => setEmail(e.target.value)} type='email' placeholder='Email or Username' icon='email.svg' />
                {error != '' ? <ErrorValidator text={error} /> : emailSent ? <SuccessValidator text="Reset Email Sent!" /> : null}
                <ButtonRed text={buttonState} handleOnClick={handleSendPasswordResetEmail} />
                <ButtonPink text='LOGIN' handleOnClick={gotoLogin} />
            </div>
        </div>
    )
}
